import React from 'react';
import classNames from 'classnames';
import { useIntl } from '../../../../util/reactIntl';
import {
  BellIcon,
  CreditCardIcon,
  MessageSquareIcon,
  TrendingUpIcon,
} from '../MerchantIcons';
import css from './FeatureGrid.module.css';

const CARDS = [
  {
    key: 'grid1',
    Icon: TrendingUpIcon,
    titleId: 'ForBusiness.grid1Title',
    descriptionId: 'ForBusiness.grid1Description',
    colorClass: 'iconPrimary',
  },
  {
    key: 'grid2',
    Icon: CreditCardIcon,
    titleId: 'ForBusiness.grid2Title',
    descriptionId: 'ForBusiness.grid2Description',
    colorClass: 'iconAccent',
  },
  {
    key: 'grid3',
    Icon: MessageSquareIcon,
    titleId: 'ForBusiness.grid3Title',
    descriptionId: 'ForBusiness.grid3Description',
    colorClass: 'iconDark',
  },
  {
    key: 'grid4',
    Icon: BellIcon,
    titleId: 'ForBusiness.grid4Title',
    descriptionId: 'ForBusiness.grid4Description',
    colorClass: 'iconPrimary',
  },
];

const FeatureGrid = () => {
  const intl = useIntl();
  const arabicLanguage =
    typeof window !== 'undefined' && localStorage.getItem('language') === 'Arabic';

  return (
    <section className={classNames(css.section, arabicLanguage && css.arabicDirection)}>
      <div className={css.inner}>
        <div className={css.header}>
          <h2 className={css.title}>{intl.formatMessage({ id: 'ForBusiness.gridTitle' })}</h2>
          <p className={css.subtitle}>{intl.formatMessage({ id: 'ForBusiness.gridSub' })}</p>
        </div>
        <div className={css.grid}>
          {CARDS.map(card => {
            const Icon = card.Icon;
            return (
              <div key={card.key} className={css.card}>
                <span className={classNames(css.iconTile, css[card.colorClass])} aria-hidden="true">
                  <Icon className={css.iconSvg} />
                </span>
                <h3 className={css.cardTitle}>{intl.formatMessage({ id: card.titleId })}</h3>
                <p className={css.cardText}>
                  {intl.formatMessage({ id: card.descriptionId })}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureGrid;
